/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// components
import AgentFilter from './AgentFilter';

function TableFilters({ handleLoadShoppers = () => {} }) {
  const dispatch = useDispatch();
  const {
    agentColumnDisplay,
    agentFilter = {},
    dispositionFilter,
  } = useSelector(store => store.leads);
  const { leadStatusOptions } = useSelector(store => store.theme);

  return (
    <>

      <div className="col-md-3">
        <AgentFilter
          openModal={() => dispatch({ type: 'OPEN_MODAL', modal: 'selectAgentModal' })}
          clearSelection={() => {
            dispatch({ type: 'SET_LEADS_KEYS', payload: { agentFilter: {} } });
            handleLoadShoppers({ agentUsername: '*' });
          }}
          inputValue={`${agentFilter.first_name || ''} ${agentFilter.last_name || ''}`}
        />
      </div>

      <div className="col-md-3">
        <label htmlFor="agent-info-select" className="form-label">
          Agent Column Display
        </label>
        <select
          id="agent-info-select"
          className="form-select"
          value={agentColumnDisplay}
          onChange={(e) => (
            dispatch({ type: 'SET_LEADS_KEYS', payload: { agentColumnDisplay: e.target.value } })
          )}
        >
          <option value="name">Name</option>
          <option value="email">Email</option>
          <option value="npn">NPN</option>
        </select>
      </div>

      <div className="col-md-3">
        <label htmlFor="agent-info-select" className="form-label">
          Disposition Filter
        </label>
        <select
          id="agent-info-select"
          className="form-select"
          value={dispositionFilter}
          onChange={(e) => {
            dispatch({ type: 'SET_LEADS_KEYS', payload: { dispositionFilter: e.target.value } });
            handleLoadShoppers({ dispositionFilter: e.target.value });
          }}
        >
          <option value="">All</option>
          {leadStatusOptions.map(opt => (
            <option value={opt.value}>{opt.description}</option>
          ))}
        </select>
      </div>

    </>
  );
}

export default TableFilters;
